import "./style.scss";
import { useState } from "react";
import BtnDefault from "@/src/components/BtnDefault/BtnDefault";
import { SidebarSvgExportConst } from "@/src/svg/sidebar/SidebarSvgExport";

type Props = {
  value: string;
  groupKey: string;
  columnID: string;
  onChange: (value: string) => void;
};

const formatDateToDisplay = (dateStr: string) => {
  if (!dateStr) return "";
  const [year, month, day] = dateStr.split("-");
  return `${day}.${month}.${year}`;
};

const DateCell = ({ value, groupKey, columnID, onChange }: Props) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedDate, setSelectedDate] = useState<string>(value);

  const handleOpen = () => {
    setIsOpen(true);
    setSelectedDate(value);
  };

  const handleOk = () => {
    onChange(selectedDate);
    setIsOpen(false);
    console.log(`current user: ${localStorage.getItem("userID")}`);
    console.log(`current column id: ${groupKey} - ${columnID}`);
    console.log(`current date: ${selectedDate}`);
  };

  const handleCancel = () => {
    setSelectedDate(value);
    setIsOpen(false);
  };

  return (
    <>
      {/* {formatDateToDisplay(value)} */}
      <p>{value}</p>
      <div className="cell-content-edit" onClick={handleOpen}>
        <SidebarSvgExportConst.CustomizationSvg />
      </div>

      {isOpen && (
        <div className="cell-content-popup-date">
          <div className="cell-content-popup-date-title">
            <p>Select date</p>
          </div>

          <div className="cell-content-popup-date-date">
            <input type="date" value={selectedDate} onChange={(e) => setSelectedDate(e.target.value)} />
          </div>

          <div className="cell-content-popup-date-buttons">
            <BtnDefault onClick={handleOk}>
              <p>Ok</p>
            </BtnDefault>
            <BtnDefault onClick={handleCancel}>
              <p>Cancel</p>
            </BtnDefault>
          </div>
        </div>
      )}
    </>
  );
};

export default DateCell;
